<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light rounded fixed-top mb-3 dy-nav">
    <router-link :to="{ name: 'index'}">
      <span class="color-default">
        <img class="w-75" src="@/static/logo.png" alt />
      </span>
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarsExample09"
      aria-controls="navbarsExample09"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarsExample09">
      <ul class="navbar-nav mr-auto d-flex flex-fill justify-content-end">
        <li class="nav-item">
          <span class="nav-link">
            <router-link :to="{ name: 'index'}">首页</router-link>
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link">
            <router-link :to="{ name: 'introduction'}">业务介绍</router-link>
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link">
            <router-link :to="{ name: 'news'}">新闻动态</router-link>
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link">
            <router-link :to="{ name: 'about'}">关于我们</router-link>
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link">
            <router-link :to="{ name: 'contact'}">联系我们</router-link>
          </span>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {};
  },
  // onload()
};
</script>>
<style lang="less">
.nav-item {
  width: 100px;
  text-align: center;
}
.active {
  color: #007bff;
}
.color-default {
  color: #333;
}
.dy-nav {
  padding: 0 10rem;
  height: 3.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue